/**
* Calendar that contains full weeks - including days of a month
* before or after the current month if they ocurr in a week
* containing days of the current month. Additional metadata
* about the month - name, year, whether a day/week/month is the
* current one - as also contained within the object.
*
* @class KOCalendar
* @requires Calendar
*/
var KOCalendar = function () {
	var self = this;

	/**
	*  Observable variables for this calendar object
	*/
	self.callback		= null;
	self.currentWeek	= ko.observable();			// Contains an Object
	self.endDate		= ko.observable( null );
	self.monthNumber	= ko.observable( null );		// Contains an Integer
	self.startDate		= ko.observable( null );		// Contains a Date object
	self.weeks			= ko.observableArray( [] );	// Contains an Array
	self.year			= ko.observable( null );		// Contains an Integer

	self.today			= ko.observable( new moment() );


	///
	/// TEMPLATES
	///

	self.weekTemplate = function () {
		return {
			days: [],
			isCurrentWeek: ko.observable( false ),
			weekNum: 0,
			year: null
		};
	};

	self.monthTemplate = function () {
		return {
			monthName: null,
			startDate: null,
			weeks: [],
			year: null
		};
	};



	///
	/// COMPUTED OBSERVABLES
	///

	/**
	* Returns the first date the calendar returns. If the first day of the calendar
	* month is not a Sunday, it backtraces into the previous month and returns the
	* date of the first Sunday of the week in which the calendar month starts.
	* If trying to access the first date of the calendar month, use the firstDay prop.
	*
	* @method firstDate
	* @return {Moment | Null}
	*/
	self.firstDate = ko.computed( function () {
		if ( self.weeks().length > 0 ) {
			return self.weeks()[0].days[0].date;
		}

		return null;
	});


	/**
	* Returns the last date the calendar returns. If the last day of the calendar
	* month is not a Saturday, it forwards into the following month and returns the
	* date of the last Saturday of the week in which the calendar month ends.
	* If trying to access the last date of the calendar month, use the lastDay prop.
	*
	* @method lastDate
	* @return {Moment | Null}
	*/
	self.lastDate = ko.computed( function () {
		var lastWeek;

		if ( self.weeks().length > 0 ) {
			lastWeek = self.weeks()[ self.weeks().length - 1 ];
			return lastWeek.days[ lastWeek.days.length - 1 ].date;
		}

		return null;
	});




	///
	/// METHODS
	///


	/**
	* Like the Calendar object this extends, this is the primary method
	* for this class/object. This method takes a date if provided and
	* constructs a Calendar object from the primitive. It then extrapolates
	* additional data about the month and turns those variabled into
	* observables which can be data bound.
	* If a date is not provided, this object will represent the current
	* calendar month.
	*
	* @method buildMonth
	* @param {Moment} [dRequestedDate] A date contained within the calendar month
	* @return {KOCalendar} Returns the object as chainable, for best practice
	*/
	self.buildMonth = function ( dDate ) {
		var dt = new moment( dDate );

		dt.hours(0);
		dt.minutes(0);
		dt.seconds(0);

		self.today( dt );

		var cal = new Calendar( dt ),
			day = null,
			dt = null,
			dy = null,
			firstWeek = cal.weeks[0],
			firstDay = cal.weeks[0].days[0],
			firstMonthDay = firstDay.day(),
			i = 0,
			j = 0,
			lastWeek = cal.weeks[ cal.weeks.length-1 ],
			lastDay = lastWeek.days[ lastWeek.days.length-1 ],
			lastMonthDay = lastDay.day(),
			mn = null,
			tDay = null,
			tWeek = null,
			week = null,
			yr = null;

		// Clear any existing weeks from our observable collection
		self.weeks.removeAll();

		// Extract observables
		self.monthNumber( firstDay.month() + 1 );
		self.startDate( firstDay );
		self.endDate( lastDay );
		self.year( firstDay.year() );


		// If the first day of the month is not Sunday, add days to the
		// beginning of the first week so that when viewing the calendar
		// we can see full weeks.
		if ( firstMonthDay != 0 ) {

			for ( i = 0; i < firstMonthDay; i++ ) {
				dt = new moment( firstDay );
				dt.date( firstDay.date() - ( i + 1 ) );

				cal.weeks[0].days.unshift( dt );
			}

		}


		// If the last day of the month is not Saturday, add days to the
		// end of the last week so that when viewing the calendar
		// we can see full weeks.
		if ( lastMonthDay != 6 ) {

			for ( i = 1; i <= 6 - lastMonthDay; i++) {
				dt = new moment( lastDay )
				dt.date( lastDay.date() + i );

				cal.weeks[ cal.weeks.length - 1 ].days.push( dt );
			}

		}


		// Now that our calendar is completed as full weeks,
		// convert each week into a Knockout observable object and
		// add metadata to each day and week.
		for ( i = 0; i < cal.weeks.length; i++) {
			week = cal.weeks[i];

			tWeek =  new self.weekTemplate();
			tWeek.weekNum = week.days[0].weekYear();
			tWeek.year = firstDay.year();

			for ( j = 0; j < 7; j++ ) {
				day = week.days[j];

				tDay = {
					id: ko.computed( function () {

						yr = day.year();
						mn = day.month() + 1;
						dy = day.date();

						mn = ((mn < 10) ? '0' : '') + mn;
						dy = ((dy < 10) ? '0' : '') + dy;

						return yr + mn + dy;
					}),
					date: day,
					dateNum: ko.observable( day.date() ),
					dayNum: day.day(),
					isCurMonth: ko.computed( function () {
						return day.month() == ( self.monthNumber() - 1 );
					}),
					isCurrentDay: ko.computed( function () {
						if ( dDate ) {
							if ( day.isSame( self.today(), 'day' ) ) {
								// We have found the day and week of the current calendar

								return true;
							}
						}

						return false;
					}),
					month: ko.observable( day.month() ),
					year: ko.observable( day.year() )

				};

				// If this method was called with a dDate parameter,
				// determine if the week containing this date is the current week
				if (dDate) {
					if ( day.isSame( self.today(), 'day' ) ) {
						// We have found the day and week of the current calendar
						//tDay.isCurrentDay = true;
						tWeek.isCurrentWeek(true);
					}
				}

				// Add the constructed day object to the week's days collection
				tWeek.days.push( tDay );
			}

			// If we have found the current week, store a reference to it in the
			// observable variable for easy retrieval
			if ( tWeek.isCurrentWeek() ) {
				self.currentWeek( tWeek );
			}

			// Finally, add the week to the calendar month's weeks collection
			self.weeks.push( tWeek );
		}

		if ( self.callback ) {
			self.callback();

			self.callback = null;
		}

		// Return self (KOCalendar) to be chainable, for best practice
		return self;

	};


	/**
	* This method allows for the KOCalendar instance to have persistence, vs
	* having to throw away the old calendar and create a new one. By passing a
	* signed integer to this method, the month can be changed forward or backward
	* any number of months
	*
	* @method changeMonth
	* @param {Integer} iChangeAmount A signed integer indicating how many months to move
	* @param {function} fCallback Function to be executed once the month has been set
	* @return {KOCalendar} Returns the object as chainable, for best practice
	*/
	self.changeMonth = function ( iChangeAmount, fCallback ) {
		var newMonth = new moment( self.startDate() );

		// if a callback was passed, save it to be executed later
		if ( fCallback ) {
			self.callback = fCallback;
		}

		newMonth.add( parseInt( iChangeAmount, 0 ), 'months' );

		self.buildMonth( newMonth, true );

		// Return self (KOCalendar) to be chainable, for best practice
		return self;
	};


	/**
	* This method allows for the KOCalendar instance to have persistence, vs
	* having to throw away the old calendar and create a new one. By passing a
	* signed integer to this method, the week can be changed forward or backward
	* any number of weeks
	*
	* @method changeWeek
	* @param {Integer} iChangeAmount A signed integer indicating how many weeks to move
	* @param {function} fCallback Function to be executed once the month has been set
	* @return {KOCalendar} Returns the object as chainable, for best practice
	*/
	self.changeWeek = function ( iChangeAmount, fCallback ) {
		var iChangeAmount = parseInt( iChangeAmount, 0 ),
			dayDiff = 0,
			newDate = new moment( self.today() ),
			weekDay = 0;

		// if a callback was passed, save it to be executed later
		if ( fCallback ) {
			self.callback = fCallback;
		}

		// Determine which day of the week today() is
		// If it is not Sunday, we will need to know which day
		// of the week today() is so that number can be added to
		// to the amount of days we are decrementing, or how many
		// days to increment to get to next Sunday.
		weekDay = newDate.day();

		// Now we need to determine if we are moving forward or backwards
		if ( iChangeAmount > 0 ) {
			// Forwards
			// Get a positive number of days to move forward to next Sunday
			dayDiff = 7 - weekDay;
		}
		else if ( iChangeAmount < 0 ) {
			// Backwards
			// Get a negative number of days to move back to Sunday of last week
			dayDiff = (7 + weekDay) * -1
		}

		newDate.add( dayDiff, 'days' );

		self.buildMonth( newDate, true );

		// Return self (KOCalendar) to be chainable, for best practice
		return self;
	};


	/**
	* This method allows for the KOCalendar instance to have persistence, vs
	* having to throw away the old calendar and create a new one. By passing a
	* signed integer to this method, the date can be changed forward or backward
	* any number of days
	*
	* @method changeDate
	* @param {Integer} iChangeAmount A signed integer indicating how many days to move
	* @param {function} fCallback Function to be executed once the month has been set
	* @return {KOCalendar} Returns the object as chainable, for best practice
	*/
	self.changeDate = function ( iChangeAmount, fCallback ) {
		// Create a copy of the current date
		var newDate = new moment( self.today() );

		// if a callback was passed, save it to be executed later
		if ( fCallback ) {
			self.callback = fCallback;
		}

		// Set the new date object ahead by the passed in parameter
		newDate.add( parseInt( iChangeAmount, 0 ), 'days' );

		// Invoke the buildMonth method, to create a new instance model
		self.buildMonth( newDate, true );

		// Return self (KOCalendar) to be chainable, for best practice
		return self;
	};


	/**
	* This method allows for the KOCalendar instance to have persistence, vs
	* having to throw away the old calendar and create a new one. By passing a
	* signed integer to this method, the month can be changed forward or backward
	* any number of months
	*
	* @method setMonth
	* @param {Integer} iMonth The month to change the calendar to
	* @param {function} fCallback Function to be executed once the month has been set
	* @return {KOCalendar} Returns the object as chainable, for best practice
	*/
	self.setMonth = function ( iMonth, fCallback ) {
		var newMonth = new moment( self.startDate() );

		// if a callback was passed, save it to be executed later
		if ( fCallback ) {
			self.callback = fCallback;
		}

		newMonth.month( iMonth );

		self.buildMonth( newMonth, true );

		// Return self (KOCalendar) to be chainable, for best practice
		return self;
	};


	// Initialize the object
	// If a date was passed when creating this KOCalendar, set that as the current date
	if ( arguments.length > 0 ) {
		self.buildMonth( arguments[0] );
	}
	// Otherwise use the current date
	else {
		self.buildMonth( self.today() );
	}

	return self;
};